<template>
  <div>
    <b-modal :id="modal_id" title="返品" size="xl" :header-bg-variant="'dark'" :header-text-variant="'light'"
      :body-bg-variant="'light'" @hide="closeModal" hide-footer centered scrollable>
      <form @submit.prevent="updateHenpin" class="form-group main_modal_div">
        <div v-if="errors.length != 0">
          <ul v-for="e in errors" :key="e">
            <li>
              <font color="red">{{ e }}</font>
            </li>
          </ul>
        </div>
        <div class="form-inline" style="margin: 10px 0px">
          <label>伝票番号</label>
          <b-input v-model="mitumori.m_code" type="text"
            :style="mitumori.cancel ? 'text-decoration: line-through; width: 200px;' : 'width: 200px;'" readonly />
          &nbsp;&nbsp;
          <label>返品番号</label>
          <b-form-select v-model="henpin.sub_code" @change="onHenpinChange" style="width: 70px">
            <option v-for="option in sel_henpin_sub_code" v-bind:value="option.value" :key="option.id">
              {{ option.text }}
            </option>
          </b-form-select>
          &nbsp;&nbsp;
          <label style="">返品日</label>
          <v-date-picker v-model="henpin.henpin_on" class="date_picker">
            <template v-slot="{ inputValue, inputEvents }">
              <b-input :value="inputValue" v-on="inputEvents" readonly />
              <b-button @click="henpin.henpin_on = null" variant="danger" class="icon_btn_del">
                <b-icon icon="x" aria-hidden="true"></b-icon>
              </b-button>
            </template>
          </v-date-picker>
          &nbsp;&nbsp;
          <label style="">納品日</label>
          <b-input v-model="nouhin.nouhin_on_fmt" type="text" style="width: 160px" disabled />
          &nbsp;&nbsp;
          <label style="">請求日</label>
          <b-input v-model="nouhin.seikyu_on_fmt" type="text" style="width: 160px" disabled />

        </div>
        <div class="form-inline" style="margin: 10px 0px">
          <label>品題</label>
          <b-input v-model="mitumori.title" type="text" style="width:200px;" :readonly="mitumori.readonly" />
          &nbsp;&nbsp;
          <label>品類</label>
          <b-input v-model="mitumori.teiki_type1" type="text" style="width:200px;" :readonly="mitumori.readonly" />
          &nbsp;&nbsp;
          <label>品目</label>
          <b-input v-model="mitumori.teiki_type2" type="text" style="width:200px;" :readonly="mitumori.readonly" />
          &nbsp;&nbsp;
        </div>
        <div class="form-inline" style="margin: 10px 0px">
          <!-- 顧客選択 -->
          <label>顧客</label>
          <b-input v-model="mitumori.client_company_name" type="text" style="width:200px; " readonly />
          <b-button v-if="!client_loading" variant="info" class="icon_btn">
            <b-icon icon="search" aria-hidden="true"></b-icon>
          </b-button>
          &nbsp;&nbsp;
          <label>敬称</label>
          <b-form-select v-model="henpin.keisyou" style="width: 70px">
            <option v-for="option in sel_keisyou" v-bind:value="option.value" :key="option.id">
              {{ option.text }}
            </option>
          </b-form-select>
          &nbsp;&nbsp;
          <label>顧客担当者</label>
          <b-form-select v-model="mitumori.client_person_id" style="width: 200px" :disabled="false">
            <option></option>
            <option v-for="option in sel_client_person" v-bind:value="option.value" :key="option.id">
              {{ option.text }}
            </option>
          </b-form-select>
          &nbsp;&nbsp;
          <label>担当者</label>
          <b-form-select v-model="mitumori.user_id" style="width: 200px" :disabled="true">
            <option v-for="option in sel_person" v-bind:value="option.value" :key="option.id">
              {{ option.text }}
            </option>
          </b-form-select>
        </div>
        <div class="form-inline" style="margin: 10px 0px">
          <label>備考</label>
          <b-form-textarea id="textarea" v-model="henpin.note" rows="2" max-rows="2" style="width: 300px;">
          </b-form-textarea>
          &nbsp;
          <b-button type="submit" variant="primary" style="margin-left: 500px">
            <b-icon icon="save"></b-icon>&nbsp;保存
          </b-button>
          &nbsp;
          <b-button @click="delHenpin" variant="danger" :disabled="henpin_sub_code == 1">
            <b-icon icon="save"></b-icon>&nbsp;削除
          </b-button>
          &nbsp;
          <b-form-checkbox id="checkbox-c" v-model="henpin.status" :value="1" :unchecked-value="0" name="checkbox-c"
            @change="henpin_submit" >
            返品確定
          </b-form-checkbox>
        </div>
      </form>
      <hr />
      商品
      <!-- 一覧 -->
      <div>
        <div style="width: 1200px; ">
          <b-table-filter :maxHeight="maxHeight" :filter_list="filter_list" :filter_val="filter_val"
            :data_list_field="data_list_field" :data_list="data_list" @on_edit='modalShow' :filter_enable="false"
            :edit_disabled="henpin.status == 1" />
        </div>
      </div>
      <div class="form-inline" style="width: 1190px">
        <div class="form-inline" style="margin: 0px 0px 0px auto;">
          <div class="ml-auto d-flex align-items-center">
            <label>返品合計</label>
            <b-input v-bind:value="sum_henpin_total + ' (税 ' + sum_henpin_tax + ')'" type="text"
              style="width: 200px; text-align: right" readonly />
          </div>
        </div>
      </div>
      相殺
      <!-- 一覧 -->
      <div>
        <div style="width: 560px; ">
          <b-table-filter :maxHeight="maxHeight" :filter_list="filter_list" :filter_val="filter_val"
            :data_list_field="offset_data_list_field" :data_list="offset_data_list" @on_delete='delOffset'
            :filter_enable="false" />
        </div>
      </div>
      <SelectMitumori @on_select='onSelectMitumori' />
      <div
        style="width: 560px; margin: -10px 0px 0px 0px; display: flex; align-items: center; justify-content: space-between;">
        <!-- 左側：ボタン -->
        <div>
          <b-button v-if="!item_loading2" @click="selectMitumoriModalShow(-1)" variant="info" class="icon_btn_w"
            v-bind:disabled="false">
            <b-icon icon="plus" aria-hidden="true"></b-icon>
          </b-button>
          <b-button v-if="item_loading2" variant="info" class="icon_btn_w" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </b-button>
        </div>
        <!-- 右側：税率ごとの合計 -->
        <div style="display: flex; align-items: center; flex-wrap: wrap; justify-content: flex-end;">
          <label>合計</label>
          <b-input v-bind:value="offset_total" type="text" style="width: 200px; text-align: right" readonly />
        </div>
      </div>
      <!-- モーダル -->
      <b-modal id="modal-mitumori_item" :title="mitumori_item_title" :header-bg-variant="'dark'"
        :header-text-variant="'light'" :body-bg-variant="'light'" hide-footer centered>
        <div class="modal_div">
          <div class="form-inline">
            <!-- 商品選択 -->
            <label v-b-tooltip.hover.bottom.v-info="tooltip_item">
              商品&nbsp;<b-icon icon="info-circle-fill" scale="1" variant="info"></b-icon>
            </label>
            <b-input v-model="mitumori_detail.master_item_name" type="text" style="width:300px; "
              @click="selectItemModalShow" readonly />
          </div>
          <div class="form-inline">
            <label>品名</label>
            <b-input v-model="mitumori_detail.item_name" type="text" style="width:300px;" readonly />
          </div>
          <div class="form-inline">
            <label>数量</label>
            <b-input v-model="mitumori_detail.quantity" type="number" min="0" readonly />
          </div>
          <div class="form-inline">
            <label>返品数量</label>
            <b-input v-model="henpin_detail.quantity" type="number" min="0" />
          </div>
          <div class="modal-footer">
            <b-button @click="$bvModal.hide('modal-mitumori_item')">
              <b-icon icon="x"></b-icon>取消
            </b-button>
            <b-button variant="primary" @click="editHenpinDetail">
              <b-icon icon="save"></b-icon>&nbsp;保存
            </b-button>
          </div>
        </div>
      </b-modal>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';

import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

import VCalendar from 'v-calendar'
Vue.use(VCalendar)

const jsonpAdapter = require('axios-jsonp');
export default {
  props: ['modal_id'],
  components: {
  },
  data: function () {
    return {
      mitumori_id: 0,
      // header
      mitumori: [],
      nouhin: [],
      mitumori_detail: [],
      sel_client_person: [],
      sel_person: [],
      sel_keisyou: [{ text: "", value: "" }, { text: "様", value: "様" }, { text: "殿", value: "殿" }, { text: "御中", value: "御中" }],
      nouhin_on_print_flg: true,
      seikyu_on_print_flg: true,
      //
      henpin: [],
      henpin_detail: [],
      henpin_sub_code: 1,
      sel_henpin_sub_code: [],

      // table
      filter_list: new Array(15),
      filter_val: new Array(15),
      data_list: [],
      data_list_field: [
        { key: "edit", label: "編集", thStyle: { width: "60px !important", textAlign: "center" }, tdClass: 'text-center', sortable: false, filter: false, edit: true },
        { key: "item_code", label: "商品コード", thStyle: { width: "120px" }, sortable: true, filter: 'input' },
        { key: "type_name", label: "商品分類", thStyle: { width: "130px" }, sortable: true, filter: 'input' },
        { key: "item_name", label: "品名", thStyle: { width: "230px" }, sortable: true, filter: 'input' },
        { key: "quantity", label: "数量", thStyle: { width: "80px" }, tdClass: 'text-right', sortable: true, filter: 'input' },
        { key: "henpin_quantity", label: "返品数量", thStyle: { width: "100px" }, tdClass: 'text-right', sortable: true, filter: 'input' },
        { key: "tanka_no_tax", label: "単価(税抜)", thStyle: { width: "120px" }, tdClass: 'text-right', sortable: true, filter: 'select' },
        { key: "tanka", label: "単価(税込)", thStyle: { width: "120px" }, tdClass: 'text-right', sortable: true, filter: 'select' },
        { key: "sum_row", label: "金額(税込)", thStyle: { width: "120px" }, tdClass: 'text-right', sortable: true, filter: 'select' },
        { key: "tax", label: "税率", thStyle: { width: "110px" }, tdClass: 'text-right', sortable: true, filter: 'select' },
      ],
      // 相殺
      offset_data_list: [],
      offset_data_list_field: [
        { key: "edit", label: "削除", thStyle: { width: "60px !important", textAlign: "center" }, tdClass: 'text-center', sortable: false, filter: false, delete: true },
        { key: "m_code", label: "伝票番号", thStyle: { width: "120px" }, sortable: true, filter: 'input' },
        { key: "item_name", label: "品名", thStyle: { width: "230px" }, sortable: true, filter: 'input' },
        { key: "sum_row", label: "金額(税込)", thStyle: {}, tdClass: 'text-right', sortable: true, filter: 'select' },
      ],
      offset_total: 0,
      // detail
      sum_total: 0,
      sum_tax: 0,
      total_by_tax: [],
      sum_henpin_total: 0,
      sum_henpin_tax: 0,
      // modal
      mitumori_detail_id: 0,
      mitumori_item_title: "商品 > 編集",
      item_loading2: false,
      sel_item_type: [],
      sel_item: [],
      tooltip_item: '　',
      msg: 'msg',
      showModal: false,
      deleteTarget: -1,
      errors: [],
      maxHeight: document.documentElement.scrollHeight - 530 + "px"
    }
  },
  mounted() {
  },
  filters: {
    customformat: function (value) {
      return value.toLocaleString();
    }
  },
  methods: {
    closeModal: function (id) {
      this.$emit('close_modal', id);
    },
    // 見積ID 
    setMitumori: async function (mitumori_id) {
      this.mitumori_id = mitumori_id;
      this.henpin_sub_code = 1
      await this.getMitumori2Nouhin();
      await this.getHenpin();
      await this.getHenpinOffset()
    },
    // 見積 取得
    getMitumori2Nouhin: async function () {
      axios
        .get(`/mitumori/get_mitumori_2_nouhin/${this.mitumori_id}`)
        .then(response => {
          this.nouhin_id = response.data.nouhin_id;
          this.getNouhin(response.data.nouhin_id);
          this.nouhin_on_print_flg = true;
          this.seikyu_on_print_flg = true;
        })
    },
    // 納品 取得
    getNouhin: function (nouhin_id) {
      axios
        .get(`/nouhin/get_nouhin/${nouhin_id}`)
        .then(response => {
          this.mitumori = response.data.mitumori_h;
          this.nouhin = response.data.nouhin_h;
          this.sel_client_person = response.data.sel_client_person;
          this.sel_person = response.data.sel_person;
        })
    },
    // 返品 変更
    onHenpinChange: async function (value) {
      if (value === -1) {
        if (confirm('新規作成しますか？')) {
          await axios
            .post(`/henpin/create_henpin/${this.mitumori_id}`)
            .then(response => {
              this.henpin_sub_code = response.data.henpin.sub_code;
            })
        }
      } else {
        this.henpin_sub_code = value;
      }
      await this.getHenpin();
      await this.getHenpinOffset()
    },
    // 返品 取得
    getHenpin: async function () {
      await axios
        .get(`/henpin/get_henpin`,
          {
            params: {
              id: this.mitumori_id,
              sub_code: this.henpin_sub_code
            }
          })
        .then(response => {
          this.henpin = response.data.henpin;
          this.sel_henpin_sub_code = response.data.sel_henpin_sub_code;
          this.getHenpinDetails();
          this.getHenpinOffset()
        })
    },
    // 返品詳細 取得
    getHenpinDetails: async function () {
      await axios
        .get(`/henpin/get_henpin_details`, {
          params: {
            id: [this.henpin.id]
          }
        })
        .then(response => {
          this.data_list = response.data.mitumori_details_h;
          this.sum_total = response.data.sum_total;
          this.sum_tax = response.data.sum_tax;
          this.total_by_tax = response.data.total_by_tax;
          this.sum_henpin_total = response.data.sum_henpin_total;
          this.sum_henpin_tax = response.data.sum_henpin_tax;
        })
    },
    // 返品 更新
    updateHenpin: function () {
      axios
        .patch(`/henpin/update_henpin`, { henpin: this.henpin })
        .then(response => {
          alert("保存しました。");
          this.getHenpin();
        })
    },
    // 返品 削除
    delHenpin: async function () {
      if (confirm('現在の返品番号を削除します。よろしいですか？')) {
        await axios
          .post(`/henpin/del_henpin/${this.henpin.id}`)
          .then(response => {
            if (response.data.flg) {
              this.henpin_sub_code = 1
              this.getHenpin();
              alert("削除しました");
            }
          })
      } else {
        this.mitumori.cancel = false;
      }
    },
    // 返品確定
    henpin_submit: function (checked) {
      if (checked) {
        if (confirm('返品を確定しますか？\n返品された商品は在庫に戻されます。')) {
          axios
            .post(`/henpin/submit_henpin/${this.henpin.id}`)
            .then(response => {
              if (response.data.flg) {
                alert('返品を確定しました。');
                this.getHenpin();
              } else {
                alert(response.data.msg);
                this.henpin.status = 0
              }

            })
        } else {
          this.henpin.status = 0
        }
      }else{
        if (confirm('返品確定を取り消しますか？')) {
          axios
            .post(`/henpin/cancel_submit_henpin/${this.henpin.id}`)
            .then(response => {
              if (response.data.flg) {
                alert('返品確定を取り消しました。');
                this.getHenpin();
              } else {
                console.log(response.data)
                alert(response.data.msg);
                this.henpin.status = 1
              }
            })
        }else{
          this.henpin.status = 1
        }
      }
    },
    // 売上・納品・請求書 印刷
    printNouhinSeikyu: function (nouhin_id) {
      axios
        .get("/nouhin/print_nouhin_seikyu/", {
          params: {
            id: [nouhin_id],
            nouhin_on_print_flg: this.nouhin_on_print_flg,
            seikyu_on_print_flg: this.seikyu_on_print_flg,
          }
        })
        .then(response => {
          this.pdfView(response.data.url);
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 商品 モーダル(新規、編集) 表示
    modalShow: function (mitumori_detail_id) {
      axios
        .get(`/henpin/get_henpin_detail`, {
          params: {
            henpin_id: this.henpin.id,
            mitumori_detail_id: mitumori_detail_id
          }
        })
        .then(response => {
          this.henpin_detail = response.data.henpin_detail;
        })
      axios
        .get(`/mitumori/get_mitumori_detail/${mitumori_detail_id}`)
        .then(response => {
          this.mitumori_detail_id = mitumori_detail_id
          this.mitumori_item_title = "返品 > 編集"
          this.mitumori_detail = response.data.mitumori_detail_h;
          this.$root.$emit('bv::show::modal', 'modal-mitumori_item');
          this.set_tooltip_item();
        })
    },
    // 保存 返品詳細 
    editHenpinDetail: function () {
      if (this.processing) return;
      this.processing = true
      axios
        .patch(`/henpin/edit_henpin_detail`, {
          henpin_id: this.henpin.id,
          mitumori_detail_id: this.mitumori_detail_id,
          quantity: this.henpin_detail.quantity
        })
        .then(response => {
          this.processing = false
          if (response.data.flg) {
            this.getHenpinDetails();
            this.getHenpinOffset();
            this.$root.$emit('bv::hide::modal', 'modal-mitumori_item')
          } else {
            alert(response.data.msg);
          }
        })
    },
    // =======================================================
    // 商品選択モーダル表示
    selectItemModalShow: function (flg) {
      if (flg == -1) {
        this.mitumori_detail_id = -1;
        this.item_loading2 = true;
      } else {
        this.item_loading = true;
      }
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'select-item')
        if (flg == -1) {
          this.item_loading2 = false;
        } else {
          this.item_loading = false;
        }
      }, 50);
    },
    // =======================================================
    // 相殺 取得
    getHenpinOffset: async function () {
      await axios
        .get(`/henpin/get_henpin_offset`, {
          params: {
            henpin_id: [this.henpin.id]
          }
        })
        .then(response => {
          this.offset_data_list = response.data.henpin_offset;
          this.offset_total = response.data.offset_total;
        })
    },
    // 見積もり選択モーダル表示
    selectMitumoriModalShow: function (flg) {
      if (flg == -1) {
        this.mitumori_detail_id = -1;
        this.item_loading2 = true;
      } else {
        this.item_loading = true;
      }
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'select-mitumori')
        if (flg == -1) {
          this.item_loading2 = false;
        } else {
          this.item_loading = false;
        }
      }, 50);
    },
    // 相殺 削除
    delOffset: function (offset_id) {
      if (confirm('削除します。よろしいですか？')) {
      axios
        .patch(`/henpin/del_henpin_offset`, {
          offset_id: offset_id
        })
        .then(response => {
          if (response.data.flg) {
            this.getHenpinOffset();
            alert("削除しました")
          } else {
            alert(response.data.msg)
          }
        })
      }
    },
    //
    onSelectMitumori: function (mitumori_id) {
      this.$root.$emit('bv::hide::modal', 'select-mitumori')
      axios
        .patch(`/henpin/set_henpin_offset`, {
          henpin_id: this.henpin.id,
          mitumori_id: mitumori_id,
        })
        .then(response => {
          if (response.data.flg) {
            this.getHenpinOffset();
          } else {
            alert(response.data.msg)
          }
        })
    },
    // =======================================================
    // 商品tooltip
    set_tooltip_item: function () {
      var tool_tip = "<font color='#f5f5f5'>商品コード: </font>" + this.mitumori_detail.item_code + "<br/>"
      tool_tip = tool_tip + "<font color='#f5f5f5'>発注先: </font>" + this.mitumori_detail.hattyu_company + "<br/>"
      tool_tip = tool_tip + "<font color='#f5f5f5'>仕入れ単価: </font>" + this.mitumori_detail.master_hattyu_tanka + "<br/>"
      tool_tip = tool_tip + "<font color='#f5f5f5'>単価: </font>" + this.mitumori_detail.master_tanka
      this.tooltip_item = { html: true, title: tool_tip }
    },
  }
}
</script>

<style scoped></style>